import { Controller } from "@hotwired/stimulus"

// Validates document signing forms before submission.
// Checks HTML5 required fields and signature pad hidden inputs.
export default class extends Controller {
  validate(event) {
    const errors = []

    // Validate all required inputs/textareas/selects
    this.element.querySelectorAll("[required]").forEach(field => {
      if (field.type === "hidden") return // skip hidden fields
      if (field.disabled) return

      if (!field.value.trim()) {
        errors.push(field)
        this.showFieldError(field)
      } else if (!field.checkValidity()) {
        errors.push(field)
        this.showFieldError(field)
      } else {
        this.clearFieldError(field)
      }
    })

    // Validate required signature — accepts either drawn (signature_data
    // populated) or typed (signature_text populated when signature_type is
    // type_to_sign). Otherwise the type-instead path can never submit.
    const sigInput = this.element.querySelector('input[name="signature_data"][data-required="true"]')
    if (sigInput) {
      const sigType = this.element.querySelector('input[name="signature_type"]')?.value
      const sigText = this.element.querySelector('input[name="signature_text"]')?.value
      const drawn = sigInput.value && sigInput.value.length > 0
      const typed = sigType === "type_to_sign" && sigText && sigText.trim().length > 0

      if (!drawn && !typed) {
        errors.push(sigInput)
        const padRoot = sigInput.closest("[data-controller~='signature-pad']") || sigInput.parentElement
        const errorEl = padRoot?.querySelector("[data-signature-pad-target='error']")
        if (errorEl) errorEl.classList.remove("hidden")
        const wrapper = padRoot?.querySelector("[data-signature-pad-target='canvasWrapper']")
        if (wrapper) wrapper.classList.add("border-danger-500")
      }
    }

    if (errors.length > 0) {
      event.preventDefault()
      // Scroll to first error
      errors[0].scrollIntoView({ behavior: "smooth", block: "center" })
    }
  }

  showFieldError(field) {
    field.classList.add("border-danger-500")
    field.classList.remove("border-neutral-300")
    field.setAttribute("aria-invalid", "true")

    // Show the input-validation error message if present
    const wrapper = field.closest("[data-controller*='input-validation']")
    if (wrapper) {
      const errorEl = wrapper.querySelector("[data-input-validation-target='error']")
      if (errorEl) errorEl.classList.remove("hidden")
    }
  }

  clearFieldError(field) {
    field.classList.remove("border-danger-500")
    field.classList.add("border-neutral-300")
    field.setAttribute("aria-invalid", "false")

    const wrapper = field.closest("[data-controller*='input-validation']")
    if (wrapper) {
      const errorEl = wrapper.querySelector("[data-input-validation-target='error']")
      if (errorEl) errorEl.classList.add("hidden")
    }
  }
}
